import { useQuery } from "@apollo/client";
import { MEALS } from "@common/schema/entry/fields";
import * as SettingsQL from "queries/settings";

// The meals the organization shows, in the order a day is eaten — what every
// list of meals in the app is cut down to.
//
// `null` until the settings are read, so a screen can hold its meal cards back
// rather than draw all four and take some away a moment later. When the read
// FAILS it is every meal: a settings outage should not empty the food log.
// `cache-first`: the screens share one read, and a save on /settings answers
// with the same cache id, so they follow it without a refetch.
export const useMeals = () => {
  const { data, error } = useQuery(SettingsQL.get, { fetchPolicy: "cache-first" });
  if (error) return MEALS;
  return data?.viewer?.account?.settings?.get?.meals || null;
};
